module.exports = __webpack_public_path__ + "src/assets/files/CMMF_Import_template.xlsx";